import { useState, useEffect } from 'react';
import { api } from '../lib/api';

export interface OrgSubscriptionDetails {
  customerId: string;
  subscriptionId: string;
  status: string;
  subscriptionQuantity: number;
  priceId: string;
  cancelAtPeriodEnd: boolean;
  unitAmount?: number;
  currency?: string;
  interval?: string;
  totalAmount?: number;
  currentPeriodStart?: number;
  currentPeriodEnd?: number;
  productId?: string;
  productName?: string;
  priceNickname?: string;
  trialEnd?: number | null;
  customerEmail?: string;
}

interface SubscriptionResponse {
  success: boolean;
  data: OrgSubscriptionDetails | null;
}

export function useOrgSubscription(orgId: string) {
  const [subscription, setSubscription] = useState<OrgSubscriptionDetails | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api
      .get<SubscriptionResponse>(`/admin/organizations/${orgId}/subscription`)
      .then(res => {
        if (!cancelled) {
          setSubscription(res.data);
          setLoading(false);
        }
      })
      .catch(err => {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Failed to load subscription');
          setLoading(false);
        }
      });
    return () => { cancelled = true; };
  }, [orgId]);

  return { subscription, loading, error };
}
